/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/certificate-common';

const styles = {
  secondaryTextMessage: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const VerifyIdNotification = () => (
  <InlineNotification
    actions={
      <Button
        component="a"
        size="small"
        variant="primary"
        href="/account-settings?verificationType=id"
        target="_blank"
        rel="noopener noreferrer"
        role="button"
      >
        {_t('Verify my ID')}
      </Button>
    }
    severity="warning"
    css={styles.secondaryTextMessage}
  >
    {_t('To ensure the correct name appears on your certificate, please complete the verification process.')}
  </InlineNotification>
);

export default VerifyIdNotification;
